
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { evaluateInit, evaluate } from '@/api/orderService';

@Component({
  name: 'OrderServicerEvaluate',
  components: { }
})
export default class extends Vue {
  private evaluateData: any = [];
  private colors = ['#f7534f', '#f7534f', '#f7534f'];
  private orderList:any=[];
  private isPl=false;

  created() {
    this.evaluateData = JSON.parse(this.$route.query.orderList as string);
    this.isPl = parseInt(this.$route.query.isPL as string) === 1;
    this.getEvaluate();
  }

  private emptyGroupHandle() {
    for (let indexOrder = 0; indexOrder < this.orderList.length; indexOrder++) {
      if (this.orderList[indexOrder].order_task_engineer_list) {
        for (let index = 0; index < this.orderList[indexOrder].order_task_engineer_list.length; index++) {
          this.orderList[indexOrder].order_task_engineer_list[index].engineerScore = 0;
        }
      }
      if (this.orderList[indexOrder].order_task_dept_list) {
        for (let index = 0; index < this.orderList[indexOrder].order_task_dept_list.length; index++) {
          this.orderList[indexOrder].order_task_dept_list[index].deptScore = 0;
        }
      }
      if (this.orderList[indexOrder].order_task_company_list) {
        for (let index = 0; index < this.orderList[indexOrder].order_task_company_list.length; index++) {
          this.orderList[indexOrder].order_task_company_list[index].companyScore = 0;
        }
      }
    }
  }
  private agreeGroupHandle() {
    for (let indexOrder = 0; indexOrder < this.orderList.length; indexOrder++) {
      let evList = this.orderList[indexOrder].order.order_evaluate;
      if (evList) {
        for (let index = 0; index < evList.length; index++) {
          const element = evList[index];
          switch (parseInt(element.e_type)) {
            case 1:
              if (!this.orderList[indexOrder].order_task_engineer_list) {
                return;
              }
              for (let index1 = 0; index1 < this.orderList[indexOrder].order_task_engineer_list.length; index1++) {
                const element1 = this.orderList[indexOrder].order_task_engineer_list[index1];
                if (element.user_id === element1.user_id) {
                  this.$set(this.orderList[indexOrder].order_task_engineer_list[index1], 'engineerScore', element.score_num);
                }
              }
              break;
            case 3:
              if (!this.orderList[indexOrder].order_task_dept_list) {
                return;
              }
              for (let index1 = 0; index1 < this.orderList[indexOrder].order_task_dept_list.length; index1++) {
                const element1 = this.orderList[indexOrder].order_task_dept_list[index1];
                if (element.dept_id === element1.dept_id) {
                  this.$set(this.orderList[indexOrder].order_task_dept_list[index1], 'deptScore', element.score_num);
                }
              }
              break;
            case 4:
              if (!this.orderList[indexOrder].order_task_company_list) {
                return;
              }
              for (let index1 = 0; index1 < this.orderList[indexOrder].order_task_company_list.length; index1++) {
                const element1 = this.orderList[indexOrder].order_task_company_list[index1];
                if (element.to_evaluate_cid === element1.company_id) {
                  this.$set(this.orderList[indexOrder].order_task_company_list[index1], 'companyScore', element.score_num);
                }
              }
              break;
          }
        }
      }
    }
  }

  private emptyClick(indexOrder:number) {
    if (this.orderList[indexOrder].order_task_engineer_list) {
      for (let index = 0; index < this.orderList[indexOrder].order_task_engineer_list.length; index++) {
        this.orderList[indexOrder].order_task_engineer_list[index].engineerScore = 0;
      }
    }
    if (this.orderList[indexOrder].order_task_dept_list) {
      for (let index = 0; index < this.orderList[indexOrder].order_task_dept_list.length; index++) {
        this.orderList[indexOrder].order_task_dept_list[index].deptScore = 0;
      }
    }
    if (this.orderList[indexOrder].order_task_company_list) {
      for (let index = 0; index < this.orderList[indexOrder].order_task_company_list.length; index++) {
        this.orderList[indexOrder].order_task_company_list[index].companyScore = 0;
      }
    }
  }
  private agreeClick(evList:any, indexOrder:any) {
    if (!evList) {
      return;
    }
    for (let index = 0; index < evList.length; index++) {
      const element = evList[index];
      switch (parseInt(element.e_type)) {
        case 1:
          if (!this.orderList[indexOrder].order_task_engineer_list) {
            return;
          }
          for (let index1 = 0; index1 < this.orderList[indexOrder].order_task_engineer_list.length; index1++) {
            const element1 = this.orderList[indexOrder].order_task_engineer_list[index1];
            if (element.user_id === element1.user_id) {
              this.$set(this.orderList[indexOrder].order_task_engineer_list[index1], 'engineerScore', element.score_num);
            }
          }
          break;
        case 3:
          if (!this.orderList[indexOrder].order_task_dept_list) {
            return;
          }
          for (let index1 = 0; index1 < this.orderList[indexOrder].order_task_dept_list.length; index1++) {
            const element1 = this.orderList[indexOrder].order_task_dept_list[index1];
            if (element.dept_id === element1.dept_id) {
              this.$set(this.orderList[indexOrder].order_task_dept_list[index1], 'deptScore', element.score_num);
            }
          }
          break;
        case 4:
          if (!this.orderList[indexOrder].order_task_company_list) {
            return;
          }
          for (let index1 = 0; index1 < this.orderList[indexOrder].order_task_company_list.length; index1++) {
            const element1 = this.orderList[indexOrder].order_task_company_list[index1];
            if (element.to_evaluate_cid === element1.company_id) {
              this.$set(this.orderList[indexOrder].order_task_company_list[index1], 'companyScore', element.score_num);
            }
          }
          break;
      }
    }
  }
  // 评价init
  private getEvaluate() {
    let ids = '';
    this.evaluateData.forEach((element:any) => {
      ids = ids + element.order_service.id + ',';
    });
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.id = ids;
    evaluateInit(pamars).then(res => {
      let resData = res.data;
      for (let index = 0; index < resData.length; index++) {
        if (resData[index].order.order_evaluate) {
          for (let index1 = 0; index1 < resData[index].order.order_evaluate.length; index1++) {
            resData[index].order.order_evaluate[index1].score_num = parseInt(resData[index].order.order_evaluate[index1].score_num);
          }
        }
      }
      this.orderList = resData;
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // private getTag(resData:any) {
  //   this.evaluateTags = resData.evaluate_tags_list;
  //   if (resData.order_task_engineer_list.length > 0) {
  //     for (var i = 0; i < resData.order_task_engineer_list.length; i++) {
  //       resData.order_task_engineer_list[i].selectTags = [];
  //       if (!this.orderTaskList) {
  //         this.orderTaskList = [];
  //       }
  //       resData.order_task_engineer_list[i].score_num = 5;
  //       this.orderTaskList.push(resData.order_task_engineer_list[i]);
  //     }
  //   }
  //   if (resData.order_task_dept_list.length > 0) {
  //     for (var m = 0; m < resData.order_task_dept_list.length; m++) {
  //       resData.order_task_dept_list[m].loc_type = 1;
  //       resData.order_task_dept_list[m].selectTags = [];
  //       if (!this.orderTaskList) {
  //         this.orderTaskList = [];
  //       }
  //       resData.order_task_dept_list[m].score_num = 5;
  //       this.orderTaskList.push(resData.order_task_dept_list[m]);
  //     }
  //   }
  //   if (resData.order_task_company_list && resData.order_task_company_list.length > 0) {
  //     for (var j = 0; j < resData.order_task_company_list.length; j++) {
  //       var temp:any = {};
  //       temp.loc_type = 2;
  //       temp.selectTags = [];
  //       if (resData.order_task_company_list[j].main_company_name) {
  //         temp.servicer_company_id = resData.order_task_company_list[j].main_company_id;
  //         temp.servicer_company_name = resData.order_task_company_list[j].main_company_name;
  //       } else {
  //         temp.servicer_company_id = resData.order_task_company_list[j].company_id;
  //         temp.servicer_company_name = resData.order_task_company_list[j].company_name;
  //       }
  //       if (!this.orderTaskList) {
  //         this.orderTaskList = [];
  //       }
  //       temp.score_num = 5;
  //       this.orderTaskList.push(temp);
  //     }
  //   }
  // }
  aa() {

  }
  private evaluateSubmit() {
    let arr:any = [];
    let flage = false;
    let ids = '';
    this.orderList.forEach((element:any) => {
      ids = ids + element.order_service.id + ',';
      let orderArr:any = [];
      if (element.order_task_engineer_list) {
        element.order_task_engineer_list.forEach((order:any) => {
          if (!order.engineerScore || parseInt(order.engineerScore) === 0) {
            flage = true;
          }
          let o:any = {};
          o.order_id = order.order_id;
          o.order_service_id = order.order_service_id;
          o.order_task_id = order.id;
          o.user_id = order.user_id;
          o.user_name = order.user_name;
          o.dept_id = 0;
          o.dept_name = '';
          o.to_evaluate_id = element.order_service.servicer_company_id;
          o.to_evaluate_cname = element.order_service.servicer_company_name;
          o.e_type = 3;
          o.score_num = order.engineerScore;
          o.detail = order.engRemark ? order.engRemark : '';
          orderArr.push(o);
        });
      }
      if (element.order_task_dept_list) {
        element.order_task_dept_list.forEach((order:any) => {
          if (!order.deptScore || parseInt(order.deptScore) === 0) {
            flage = true;
          }
          let o:any = {};
          o.order_id = order.order_id;
          o.order_service_id = order.order_service_id;
          o.order_task_id = order.id;
          o.user_id = 0;
          o.user_name = '';
          o.dept_id = order.dept_id;
          o.dept_name = order.dept_name;
          o.to_evaluate_id = element.order_service.servicer_company_id;
          o.to_evaluate_cname = element.order_service.servicer_company_name;
          o.e_type = 1;
          o.score_num = order.deptScore;
          o.detail = order.deptRemark ? order.deptRemark : '';
          orderArr.push(o);
        });
      }
      if (element.order_task_company_list) {
        element.order_task_company_list.forEach((order:any) => {
          if (!order.companyScore || parseInt(order.companyScore) === 0) {
            flage = true;
          }
          let o:any = {};
          o.order_id = order.order_id;
          o.order_service_id = order.order_service_id;
          o.order_task_id = order.id;
          o.user_id = 0;
          o.user_name = '';
          o.dept_id = 0;
          o.dept_name = '';
          o.to_evaluate_id = element.order_service.servicer_company_id;
          o.to_evaluate_cname = element.order_service.servicer_company_name;
          o.e_type = 1;
          o.score_num = order.companyScore;
          o.detail = order.companyRemark ? order.companyRemark : '';
          orderArr.push(o);
        });
      }
      arr.push(orderArr);
    });
    if (flage) {
      this.showErrorMsg('请勾选评价分数');
      return;
    }
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.id = ids;
    pamars.evaluate = JSON.stringify(arr);
    evaluate(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.$router.go(-1);
    }).catch((err: { msg: string; }) => {
      this.showErrorMsg(err.msg);
    });
  }

  // 详情
  private getDetail(val: any) {
    let routeData = this.$router.resolve({
      path: '/OrderServicer/todetail',
      query: {
        order_service_id: val.order_service.id,
        company_id: val.order_service.servicer_company_id,
      }
    });
    window.open(routeData.href);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
